import {
    SET_USER_ACCEPT_RULES,
    SET_USER_MAIL,
    SET_USER_PASSWORD,
    ON_BLUR_MAIL,
    ON_BLUR_PASSWORD,
    REGISTER_PENDING,
    REGISTER_FULFILLED,
    REGISTER_REJECTED,
} from '../../../constants/ActionTypes';
import RegisterInitialState from './RegisterInitialState';

function registerReducer(state = RegisterInitialState, action) {
    switch (action.type) {
    case SET_USER_MAIL:
        return {
            ...state,
            user: {
                ...state.user,
                mail: action.event.target.value,
                isValidMail: action.isValidMail,
            },
        };
    case SET_USER_PASSWORD:
        return {
            ...state,
            user: {
                ...state.user,
                password: action.event.target.value,
                isValidPassword: action.isValidPassword,
            },
        };
    case SET_USER_ACCEPT_RULES:
        return {
            ...state,
            user: {
                ...state.user,
                acceptedRules: action.acceptedRules,
            },
        };
    case ON_BLUR_MAIL:
        return {
            ...state,
            user: {
                ...state.user,
                showMailError: action.showMailError,
            },
        };
    case ON_BLUR_PASSWORD:
        return {
            ...state,
            user: {
                ...state.user,
                showPasswordError: action.showPasswordError,
            },
        };
    case REGISTER_PENDING:
        return {
            ...state,
            isPending: true,
        };
    case REGISTER_FULFILLED:
        return {
            ...state,
            isPending: false,
        };
    case REGISTER_REJECTED:
        return {
            ...state,
            isPending: false,
            error: action.payload.message,
            errorMail: action.payload.mail,
        };
    default:
        return state;
    }
}

export default registerReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/Register/registerReducer.js